import StatusBar16ProMax from "./StatusBar16ProMax";
import PropTypes from "prop-types";

const FrameComponent = ({ className = "" }) => {
  return (
    <section
      className={`flex flex-row items-start justify-start pt-0 px-0 pb-[69px] box-border max-w-full ${className}`}
    >
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="#fff"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
    </section>
  );
};

FrameComponent.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent;
